import { module as modujs } from "modujs";

import fuzzysort from "fuzzysort";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				radio: "radioStyle",
			},
		};

		this._clickHandlers = new Map();
		this._changeHandlers = new Map();
	}

	init() {
		this.$groups = this.$("group").length > 0 ? this.$("group") : [this.el];
		this.$counts = this.$("count");
		this.$submits = this.$("submit");
		this.$filters = this.$("filter");
		this.$resets = this.$("reset");
		this.$radios = this.$("radio");

		this.filtersConfig = JSON.parse(this.getData("config"));

		this.buildFiltersObject();

		if (this.filtersConfig.onSubmit) {
			this.$submits.forEach(($submit) => {
				let _clickHandler = this.buildFiltersObject.bind(this);
				this._clickHandlers.set($submit, _clickHandler);
				$submit.addEventListener("click", _clickHandler);
			});
		} else {
			this.$filters.forEach(($filter) => {
				let _changeHandler = this.buildFiltersObject.bind(this);
				this._changeHandlers.set($filter, _changeHandler);
				$filter.addEventListener("input", _changeHandler);
			});
		}

		this.$resets.forEach(($reset) => {
			$reset.addEventListener("click", () => this.resetFilters());
		});
	}

	buildFiltersObject() {
		this.filtersObj = [];

		this.$groups.forEach(($group) => {
			var filtersGroupObj = {};
			var $filters = $group.querySelectorAll('[data-filters="filter"]');

			// Loop through each filters of the group
			$filters.forEach(($filter) => {
				var key = $filter.dataset.filtersKey;
				var value = "";
				var type = $filter.type;

				if (type == "radio" || type == "checkbox") {
					if ($filter.checked) {
						value = $filter.value;
					}
				} else {
					value = $filter.value;
				}

				if (filtersGroupObj[key] == undefined) {
					filtersGroupObj[key] = [];
				}

				if (value) {
					filtersGroupObj[key].push(value);
				}
			});

			// Add filters group object to the main filters object
			this.filtersObj.push(filtersGroupObj);
		});

		if (this.filtersConfig.urlHash) {
			this.buildUrl();
		}

		this.$counts.forEach(($count) => {
			let count = 0;

			this.filtersObj.forEach((filtersGroupObj) => {
				for (var key in filtersGroupObj) {
					count += filtersGroupObj[key].length;
				}
			});

			$count.innerText = count;
		});

		this.updateView();
	}

	buildUrl() {
		const url = new URL(window.location.href);

		this.filtersObj.forEach((filtersGroupObj) => {
			for (var key in filtersGroupObj) {
				if (filtersGroupObj[key] != "") {
					url.searchParams.set(key, filtersGroupObj[key]);
				} else {
					url.searchParams.delete(key);
				}
			}
		});

		window.history.pushState("", "", url);
	}

	updateView() {
		var resultsObj = [];
		var filterFor = this.filtersConfig.for;

		document.querySelectorAll('[data-filters-items="' + filterFor + '"]').forEach(($filtersItems) => {
			var isEmpty = true;

			const $scopedItems = Array.from($filtersItems.querySelectorAll("[data-filters-item]")).filter(($item) => {
				return !$item.closest("[data-filters-items]") || $item.closest("[data-filters-items]") === $filtersItems;
			});

			$scopedItems.forEach(($filtersItem) => {
				var groupMatches = 0;
				var filterItemObj = $filtersItem.dataset.filtersItem;
				filterItemObj = JSON.parse(filterItemObj);

				this.filtersObj.forEach((filtersGroupObj) => {
					var match = false;
					var groupActive = false;

					for (var key in filtersGroupObj) {
						var filterItemValue = filterItemObj[key];

						if (filterItemValue) {
							filterItemValue = filterItemValue.split(",");
						} else {
							filterItemValue = [];
						}

						var filtersObjValue = filtersGroupObj[key];

						if (key == "fsearch") {
							if (filtersObjValue.length) {
								groupActive = true;

								var search = filtersObjValue[0];
								const targets = [filterItemObj];

								const options = {
									threshold: 0.5,
									keys: Object.keys(filterItemObj),
								};

								const results = fuzzysort.go(search, targets, options);

								if (results.total > 0) {
									var resultsArr = [];
									match = true;

									results[0].forEach((result, index) => {
										resultsArr.push({
											key: Object.keys(filterItemObj)[index],
											hightlight: result.highlight("<em>", "</em>"),
											score: result.score,
										});
									});

									resultsObj.push({
										node: $filtersItem,
										results: resultsArr,
									});

									break;
								}
							}
						} else {
							if (filtersObjValue.length && filterItemValue.length) {
								groupActive = true;

								if (filtersObjValue.some((item) => filterItemValue.includes(item))) {
									match = true;
									break;
								}
							}
						}
					}

					if ((groupActive && match) || !groupActive) {
						groupMatches++;
					}
				});

				if (groupMatches == this.filtersObj.length) {
					$filtersItem.classList.add("is-match");
					isEmpty = false;
				} else {
					$filtersItem.classList.remove("is-match");
				}
			});

			if (isEmpty) {
				$filtersItems.classList.add("is-empty");
			} else {
				$filtersItems.classList.remove("is-empty");
			}

			this.el.dispatchEvent(
				new CustomEvent("filters:after", {
					detail: { isEmpty: isEmpty, searchResults: resultsObj },
				})
			);
		});
	}

	resetFilters() {
		this.$filters.forEach(($filter) => {
			if ($filter.tagName == "SELECT") {
				$filter.selectedIndex = 0;
			}
			if ($filter.tagName == "INPUT") {
				if ($filter.type == "text" || $filter.type == "search") {
					$filter.value = "";
				}
				if ($filter.type == "checkbox" || $filter.type == "radio") {
					$filter.checked = false;
				}
			}
		});

		this.el.dispatchEvent(new CustomEvent("filters:reset"));

		this.buildFiltersObject();
	}

	radioStyle(e) {
		this.$radios.forEach(($radio) => {
			$radio.classList.remove("-active");
		});

		e.currentTarget.classList.add("-active");
	}

	destroy() {
		this._clickHandlers.forEach((handler, element) => {
			element.removeEventListener("click", handler);
		});
		this._clickHandlers.clear();

		this._changeHandlers.forEach((handler, element) => {
			element.removeEventListener("change", handler);
		});
		this._changeHandlers.clear();
	}
}
